// BERRY-1358 prefer no_category from @atlassian/jira-servicedesk-work-category certainly?
export const NO_PRACTICE = 'no-practice' as const;
